(function() {
angular.module('app.ui.form.ctrls')
.controller('AdminAppliedJobs', [
    '$scope', '$log', '$http', 'sharedProperties', 'currentLawyer', 'usSpinnerService', 'logger', '$location', function($scope, $log, $http, sharedProperties, currentLawyer, usSpinnerService, logger, $location) {
      $scope.lawyerjobs = [];
      sharedProperties.verifyUser(_.range(11,18));
      $scope.picSrc = 'images/firm-logo-default.jpg';
      $scope.showSuccessMsg = false;
      $scope.showErrorMsg = false;
      $scope.alertMsg = '';
      $scope.firms = [];
      $scope.showNoJobs = false;
      $scope.openJobs = [];
      $scope.closedJobs = [];
      $scope.isDataFetched = false;
      $scope.jobStatus = [
        {
          state: "Applied"
        }, {
          state: "Line"
        }, {
          state: "Review"
        }, {
          state: "Interview"
        }, {
          state: "Unsuccessful"
        }, {
          state: "Offer"
        }
      ];
      $scope.jobOptionsList = [
        {
          option: "Interview"
        }, {
          option: "Offer"
        }, {
          option: "Accepted"
        }
      ];
      let liveJobsStatuses = [
        "Applied"
        , "Line"
        , "Review"
        , "Interview"
        , "Pending Interview"
      ],
      processedJobsStatues = [
        "Unsuccessful"
        , "Offer"
        , "Rejected by Firm"
      ];
      $scope.showClass = "";
      $scope.showJobDetail = function(job) {
        if (!job.expanded) {
          job.expanded = true;
          job.isExpanded = false;
          $http.post('/api/fetch-job-practices', {
            id: job.jobData.job_ID
          })
          .then(function ({data}){
            job.targetedJobPracticeAreas = data;
						},function (error){
              $log.info('error: ',error);
						});
          $http.post('/api/fetch-job-locations', {
            job_ID: job.jobData.job_ID
          })
          .then(function ({data}){
            var location;
            job.targetedLocations = data;
            location = _.findWhere(data, {
              "loc_name": job.jobData.job_location
            });
            if (location) {
              job.loc_color = location.loc_color;
            }
						},function (error){
              $log.info('error: ',error);

            });
        } else {
          job.expanded = false;
        }
      };
      $scope.hideDropDown = function() {
        $scope.showClass = "";
      };
      $scope.showDropDown = function() {
        if ($scope.showClass === "") {
          $scope.showClass = "show";
        } else {
          $scope.showClass = "";
        }
      };

      $scope.notify = function(type, message) {
        switch (type) {
          case 'info':
            logger.log("Heads up! This alert needs your attention, but it's not super important.");
            break;
          case 'success':
            logger.logSuccess(message);
            break;
          case 'warning':
            logger.logWarning("Warning! Best check yo self, you're not looking too good.");
            break;
          case 'error':
            logger.logError("Oh snap! Change a few things up and try submitting again.");
        }
      };
      this.logOut = function() {
        sharedProperties.logOut();
      };
      $scope.showLawyerProfile = function() {
        $location.url('/admin/lawyer-profile');
      };
      var spinnerActive = true;
      $scope.fetchLawyerJobs = function() {
        setTimeout((function() {
          if (spinnerActive)
            usSpinnerService.spin('spinner-ajl');
        }), 1);
        $http.post('/api/fetch-lawyer-jobs', {
          id: $scope.loggedInLawyer.lawyer.lawyer_ID
        })
        .then(function({data}){
          $http.post('/api/fetch-lawyer-firms', {
            id: $scope.loggedInLawyer.lawyer.lawyer_ID
          })
          .then(function({data}){
            let firmData=data;
						$scope.lawyerfirms = firmData;
            firmData.forEach(firm =>{
              if (_.contains(liveJobsStatuses, firm.status)) {
                firm.liveStatus = "Live Firm Applications";
              } else if (_.contains(processedJobsStatues, firm.status)) {
                firm.liveStatus = "Processed Firm Applications";
              }
              if (firm.profile_Picture === null) {
                firm.picSrc = $scope.picSrc;
              } else {
                firm.picSrc = sharedProperties.getImgSrc(firm.profile_Picture, firm.user_ID,true);
              }
              firm.job_title = "Connect with "+firm.firm_Name;
            })
						},function (error){
              $log.info("error: ",error);
            });            
          if (data.length <= 0) {
            $scope.showNoJobs = true;
          }
          else{
            $scope.showNoJobs = false;
          }

          if (data.length > 0){
            $scope.lawyerjobs = [];
            data.forEach(function(job,index) {
              var tJob = {
                createdAt : job.jobApplicationDate
              , firmName : job.firm_Name
              , is_accepted : job.is_accepted
              , is_interviewed : job.is_interviewed
              , is_offered : job.is_offered
              , feedBack: job.feedBack
              , jobData : job
              , jobJobID : job.job_ID
              , lawyerLawyerID : $scope.loggedInLawyer.lawyer.lawyer_ID
              , sent : job.sent
              , status : job.status
              , appliedOffPlatform: job.appliedOffPlatform,
              job_is_visible : job.job_is_visible,
              firm_Visibility : job.firm_Visibility,
              hiddenFirm : job.hiddenFirm,
              hiddenJob : job.hiddenJob,
              job_min_pqe : job.job_min_pqe,
              job_max_pqe : job.job_max_pqe,
              employerTypeID : job.employerTypeID,
              parentStage:job.parentStage,
              childState:job.childState,
              parentStageId:job.parentStageId,
              archived:job.archived,
              lastStatusChange:job.lastStatusChange
              };

              if (job.archived == "Active" || job.archived == null) {
                tJob.liveStatus = "Live Jobs";
              } else {
                tJob.liveStatus = "Archived";
              }

              if (job.profile_Picture === null) {
                tJob.picSrc = $scope.picSrc;
              } else {
                tJob.picSrc = sharedProperties.getImgSrc(job.profile_Picture, job.firm_user_ID,true);
              }
              $scope.lawyerjobs.push(tJob);
              if (index == (data.length-1)){
                spinnerActive = false;
                usSpinnerService.stop('spinner-ajl');
              }

              return $scope.isDataFetched = true;
            });            
          }
          else{
            spinnerActive = true;
            usSpinnerService.stop('spinner-ajl');
            $scope.showNoJobs = true;
            $scope.isDataFetched = true
          }
          },function ({error,status}){
            $log.info('error: ',error);
            if (status === 440) {
              $location.url('/signin');
            }

          });
      };

      $scope.updateJobInfo = function(job) {
        $http.post('/api/update-lawyer-job-info', job)
        .then(function () {
          var message;
          message = 'Successfully updated.';
          $scope.notify('success', message);
        }, function({status}) {
          $scope.alertMsg = 'Internal Server Error.';
          $scope.showErrorMsg = true;
          if (status === 440) {
            return $location.url('/signin');
          }
        });
      };
      $scope.updateFirmInfo = function(firm) {
        $http.post('/api/update-lawyer-firm-info', firm).then(function() {
          var message;
          message = 'Successfully updated.';
          $scope.notify('success', message);
        },function({status}) {
          $scope.alertMsg = 'Internal Server Error.';
          $scope.showErrorMsg = true;
          if (status === 440) {
            return $location.url('/signin');
          }
        });
      };

      $scope.updateFirmStatus = function(firm, status) {
        var updateJob;
        updateJob = {
          cur_firm: firm,
          new_status: status
        };
        if (status.state === "Unsuccessful" || status.state === "Offer" || status.state === "Rejected by Firm") {
          firm.liveStatus = "Processed Firm Applications";
        } else {
          firm.liveStatus = "Live Firm Applications";
        }
        $http.post('/api/update-lawyer-firm', updateJob).then(function() {
          var message;
          message = 'Status has been changed Successfuly.';
          $scope.notify('success', message);
        },function({status}) {
          $scope.alertMsg = 'Internal Server Error.';
          $scope.showErrorMsg = true;
          if (status === 440) {
            return $location.url('/signin');
          }
        });
      };
      $scope.populateLawyerjobs = function(data) {
        $scope.lawyerjobs.forEach(function(lawyerjob) {
          return data.forEach(function(jobs) {
            if (lawyerjob.jobJobID === jobs.job_ID) {
              lawyerjob.jobData = jobs;
            }
          });
        });
      };
      $scope.populateFirmData = function() {
        $scope.lawyerjobs.forEach(function(lawyer_job) {
          if (lawyer_job.status === "Applied" || lawyer_job.status === "Line" || lawyer_job.status === "Review" || lawyer_job.status === "Interview" || lawyer_job.status === "Pending Interview") {
            lawyer_job.liveStatus = "Live Jobs";
          } else if (lawyer_job.status === "Unsuccessful" || lawyer_job.status === "Offer" || (lawyer_job.status = "Rejected by Firm")) {
            lawyer_job.liveStatus = "Processed Jobs";
          }
          $scope.firms.forEach(function(firm) {
            if (lawyer_job.jobData.firmFirmID === firm.firm_ID) {
              lawyer_job.firmName = firm.user.firm_Name;
              if (firm.user.profile_Picture === null) {
                lawyer_job.picSrc = $scope.picSrc;
              } else {
                lawyer_job.picSrc = sharedProperties.getImgSrc(firm.user.profile_Picture, firm.user.user_ID,true);
              }
            }
          });
        });
        $scope.isDataFetched = true;
      };
      let applicationstagelist=[
        {"id":2,"name":"Applied"},
        {"id":3,"name":"Shortlisted"},
        {"id":4,"name":"Submitted"},
        {"id":5,"name":"Interview"},
        {"id":6,"name":"Hired"}
      ]
      $scope.applicationPipeline=applicationstagelist;
      $scope.fetchApplicationActiveTab = function(job_ID,stageid,parentid,status) {
        if(stageid===parentid){
          // let color="#6ec56e";
          let color="#ffef00"; 
          if(status=="Accepted")
          color="#008000" 
          else if(status=="Rejected by LexStep")
            color="#ffa500"
          else if(status=="Employer Declined" || status =="Candidate Withdrew")
            color="#ff0000"   
           var test = angular.element('#'+job_ID+stageid); 
          test.css('background', color);
          if(test.length>0){
            test[0].children[0].style.borderColor =
                    color +" "+ color + " transparent transparent";
            test[0].children[0].style.boxShadow =
                    "1.4px -1.4px 0px 0px " + color;
          }
        }       
      };
      $scope.fetchLawyerJobs();
    }
  ]);
}());



// WEBPACK FOOTER //
// ./scripts/admin-applied-jobs/AdminAppliedJobs.js